import { HttpClient, HttpHeaders, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Environment } from "app/decorators/environment.decorator";
import { Observable, tap } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class AuthService {

    @Environment('baseUrl') baseUrl: string;

    constructor(private http: HttpClient) {}

    login(login: string, password: string, tenantId: string): Observable<HttpResponse<any>> {
        let headers = new HttpHeaders();
        const body = { login, password };

        if (tenantId) {
            headers = headers.set("X-TenantID", tenantId);
            localStorage.setItem("tenantId", tenantId);
        }
    
        return this.http.post(this.baseUrl+"authenticate", body, {
          headers,
          observe: 'response' // Captura a resposta completa, incluindo os headers
        }).pipe(tap(response => this.storeTokenFromResponse(response)));
      }

    patientLogin(credentials: any, tenantId: string = this.getTenantId()): Observable<HttpResponse<any>> {
        let headers = new HttpHeaders();
        localStorage.removeItem("token");

        if (tenantId) {
            headers = headers.set("X-TenantID", tenantId);
            localStorage.setItem("tenantId", tenantId);
        }

        return this.http.post(this.baseUrl + "patient/authenticate", credentials, {
            headers,
            observe: "response"
        }).pipe(tap(response => this.storeTokenFromResponse(response)));
    }

    logout() {
        localStorage.removeItem("token");
    }

    getToken(): string | null {
        return localStorage.getItem("token");
    }

    async runWithAdminToken<T>(operation: () => Promise<T>): Promise<T> {
        const currentToken = this.getToken();

        await this.login("admin", "teste123", this.getTenantId() || "").toPromise();

        try {
            return await operation();
        } finally {
            if (currentToken) {
                localStorage.setItem("token", currentToken);
            } else {
                localStorage.removeItem("token");
            }
        }
    }

    getTenantId(): string | null {
        const savedTenant = localStorage.getItem("tenantId");
        const host = window.location.hostname;
        const portalTenant = host.match(/^portal\.([^.]+)/);

        if (portalTenant && portalTenant[1]) {
            return portalTenant[1];
        }

        return savedTenant;
    }

    private storeTokenFromResponse(response: HttpResponse<any>): void {
        const token = response.headers.get("X-Auth-Token");

        if (token) {
            localStorage.setItem("token", token.replace("Bearer ", ""));
        }
    }
}
